export const NODE_ENV = process.env.NODE_ENV;
